// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ChevronUpSmall: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M17.053 15.947a.91.91 0 0 0 .663-.284c.19-.19.284-.41.284-.663a.909.909 0 0 0-.284-.663l-5.053-5.053A.91.91 0 0 0 12 9a.91.91 0 0 0-.663.284l-5.053 5.053A.91.91 0 0 0 6 15a.91.91 0 0 0 .284.663c.19.19.41.284.663.284a.91.91 0 0 0 .664-.284L12 11.273l4.39 4.39c.189.19.41.284.663.284Z" />
  </SvgIcon>
);

ChevronUpSmall.activeColor = 'inherit';
ChevronUpSmall.muiName = 'ChevronUpSmall';
